import { SimpleUser } from "./simple-user";

export class BookingChat {

    constructor(
        public message: string,
        public created?: string,
        public createdBy?: SimpleUser,
        public id?: number,
        public studentName?: string
    ){}
}
